<lib-chatbot #commonChatbot [botResponse]="chatBotResponse" (questionAsked)="onChatbotQuestion($event)"
    [mentionGroups]="mentionGroups" (queryCancelled)="onChatbotCancel()" (chatClosed)="onChatbotClose()"
    [welcomeMessage]="welcomeMessage" [exampleQuestions]="exampleQuestions" (newChatStarted)="newChatOpen()"
    [chatHistory]="chatHistory" (historySelected)="selectChatHistory($event)" [threadHistory]="selectedThreadHistory">
</lib-chatbot>